<template>
	<div class="app-container" :class="{ 'dark-theme': isDark }">
		<el-card class="table-card">
			<div slot="header" v-if="isPageTitle"
				style="display: flex;justify-content: space-between;align-items: center;">
				<span style="font-size: 16px;color:#409EFF ;">{{routeMeta}}</span>
				<div style="display: flex;">
					<slot name="headerAction"></slot>
					<el-button 
						type="success" 
						v-if="showExport" 
						style="margin-left: 10px;" 
						plain 
						icon="el-icon-download"
						size="mini" 
						@click="handleExport">导出Excel</el-button>
					<el-button type="primary" v-if="ifPageAdd" style="margin-left: 10px;" plain icon="el-icon-plus"
						size="mini" @click="handleAdd()">新增</el-button>
				</div>
			</div>

			<el-form v-if="searchList.length" :model="queryParams" ref="queryForm" size="small" :inline="true"
				v-show="showSearch" label-width="68px">
				<el-form-item v-for="(item,index) in searchList" :key="index" :prop="item.prop">
					<el-input v-model.trim="queryParams[item.prop]" v-if="item.type==='input'"
						:placeholder="`请输入${item.label}`" clearable @keyup.enter.native="getList('search')" />
					<el-input 
						v-if="item.type==='textarea'"
						v-model="queryParams[item.prop]"
						type="textarea"
						:rows="item.rows || 2"
						:placeholder="item.placeholder || `请输入${item.label}，多个用逗号或换行分隔`"
						clearable
						:style="{ width: item.width || '260px', verticalAlign: 'middle' }" />						
					<el-cascader style="width: 100%;" v-if="item.type==='cascader'" @change="getList('search')"
						filterable :show-all-levels="false" :placeholder="`请选择${item.label}`" :options="item.selectList"
						:props="{
						        checkStrictly: true,
						        emitPath: false,
								...item.props
						    }" v-model="queryParams[item.prop]" clearable></el-cascader>

					<el-select 
						v-model="queryParams[item.prop]" 
						filterable 
						v-if="item.type==='select' || item.type==='multipleSelect'"
						:multiple="item.multiple || item.type==='multipleSelect'"
						:collapse-tags="item.collapseTags !== false"
						@clear="handleClear(item)"
						@change="handleChange(item)"
						clearable 
						:placeholder="`请选择${item.label}`">
						<el-option v-for="select in item.selectList" :key="select.value" :label="select.label"
							:value="select.value">
						</el-option>
					</el-select>
					<el-date-picker v-if="item.type==='date'" v-model="queryParams[item.prop]"
						:type="item.dateType||'date'" :value-format="item.format||'yyyy-MM-dd'"
						:placeholder="`选择${item.label}`" />
					<el-date-picker v-model="queryParams[item.prop]" v-if="item.type==='daterange'"
						@change="changDaterange($event,item)" type="daterange" range-separator="至"
						:start-placeholder="`${item.label}开始`" value-format="yyyy-MM-dd" :end-placeholder="`${item.label}结束`">
					</el-date-picker>
					<el-date-picker v-model="queryParams[item.prop]" v-if="item.type==='datetimerange'"
						@change="changDaterange($event,item)" type="datetimerange" range-separator="至"
						:start-placeholder="`${item.label}开始`" value-format="yyyy-MM-ddTHH:mm:ss.SSSZ" :end-placeholder="`${item.label}结束`">
					</el-date-picker>

				</el-form-item>
				<el-form-item>
					<el-button type="primary" icon="el-icon-search" @click="getList('search')">搜索</el-button>
					<el-button icon="el-icon-refresh" @click="getList('remove')">重置</el-button>

				</el-form-item>
			</el-form>
			<!-- ✅ height / max-height 都会冻结表头；
			     没显式传 height 时用 max-height，短表格不会被撑高 -->
			<el-table ref="tableRef" v-loading="loading" :size="size" border :data="dataList" :row-key="rowKey"  :expand-row-keys="expandedRowKeys" @expand-change="handleExpandChange" 
			@selection-change="handleSelectionChange" :show-summary="showSummary"
    	    :summary-method="summaryMethod" :height="tableHeight || computedHeight" :max-height="tableMaxHeight">
				<el-table-column v-if="showExpand" type="expand" width="50">
					<template slot-scope="props">
						<slot name="expand" :row="props.row"></slot>
					</template>
				</el-table-column>
				<el-table-column v-if="selection" type="selection" sortable width="50" align="center" reserve-selection/>
				<el-table-column v-for="(item,index) in showColumnList" :key="index" :label='item.label'
					:prop="item.prop" :min-width="item.width" :align="item.align||'center'" :fixed="item.fixed">

					<template slot-scope="{ row }">
						<slot v-if="item.slot" :name="item.slot" :row="row"></slot>
						<div v-else-if="item.type==='img'">

							<el-carousel height="80px" indicator-position="none"
								v-if="((item.showFunction?item.showFunction(row[item.prop]||'',row):row[item.prop])||'').split(',').length>1">
								<el-carousel-item :key="imgIndex"
									v-for="(img,imgIndex) in ((item.showFunction?item.showFunction(row[item.prop],row):row[item.prop])||'').split(',')">
									<ImageViewer :src="img"
										:previewSrcList="((item.showFunction?item.showFunction(row[item.prop],row):row[item.prop])||'').split(',')" />
								</el-carousel-item>
							</el-carousel>
							<ImageViewer
								v-else-if="((item.showFunction?item.showFunction(row[item.prop]||'',row):row[item.prop])||'').split(',').length==1"
								:src="item.showFunction?item.showFunction(row[item.prop]||'',row):row[item.prop]||''" />
						</div>

						<el-color-picker v-else-if="item.type==='color'" v-model="row[item.prop]"></el-color-picker>

						<span v-else-if="item.showFunction"
							:style="{color:item.showFunction(row[item.prop],row).color}">
							{{item.showFunction(row[item.prop],row).text}}
						</span>
						<span v-else-if="item.type==='text'" style="text-align: left;">
							<div style="white-space: pre-wrap;" v-text="row[item.prop]">

							</div>
						</span>
						<span v-else-if="item.prop">
							{{row[item.prop]}}
						</span>
					</template>


				</el-table-column>
			</el-table>
			<el-pagination :size="size" style="margin-top: 10px;" v-show="total > 0" align="right" background
				:page-size="queryParams.PageSize" :total="total" layout="total, sizes, prev, pager, next, jumper"
				:current-page="queryParams.Page" @size-change="handleSizeChange"
				@current-change="handleCurrentChange" />
		</el-card>
		<el-dialog :title="updateTitle" :key="addOpen" :close-on-click-modal="false" top="15px" destroy-on-close
			:visible.sync="addOpen" :width="addPopWidth" append-to-body>
			<AddForm :isTitle="false" :isUpdate="Boolean(addData&&addData.id)" :isPageForm="isPageSubmit" ref="addForm"
				:upDateApi="upDateApi" :formApi="formApi" @submitForm="submitForm"
				@submitFormSuccess="getList('search')" :btn-text="addFormBtn" :formData="formListUpdate||addFormList" />
		</el-dialog>

	</div>
</template>

<script>
	import api from "@/utils/api";
	import AddForm from './Form.vue'
	import * as XLSX from 'xlsx' // 安装: npm install xlsx
	export default {
		name: 'TableList',
		activated() {
			// 从 sessionStorage 恢复搜索条件
			const key = `tableList_${this.$route.path}_queryParams`
			const savedParams = sessionStorage.getItem(key)
			if (savedParams) {
				try {
					const parsed = JSON.parse(savedParams)
					Object.keys(parsed).forEach(k => {
						if (k !== 'Page' && k !== 'PageSize') {
							this.queryParams[k] = parsed[k]
						}
					})
				} catch (e) {
					console.error('恢复搜索条件失败', e)
				}
			}
		},
		beforeRouteLeave(to, from, next) {
			// 离开前保存搜索条件到 sessionStorage
			const key = `tableList_${this.$route.path}_queryParams`
			sessionStorage.setItem(key, JSON.stringify(this.queryParams))
			next()
		},
		data() {
			return {
				isDark: false,
				// 遮罩层
				loading: true,
				// 商品分类树结构列表
				// 选中数组
				ids: [],
				// 非单个禁用
				single: true,
				// 总条数
				total: 0,
				// 是否显示弹出层
				addOpen: false,
				// 商品信息列表
				dataList: [],
				// 非多个禁用
				multiple: true,
				// 显示搜索条件
				showSearch: true,
				// 查询参数
				queryParams: {
					Page: 1,
					PageSize: 10,
				},
				addData: null,
				isClearing:false,
				// 展开行的key数组
				expandedRowKeys: [],
				selectedRows: [],
				// ✅ 自适应高度（autoHeight 开启且未传 tableHeight 时生效）
				computedHeight: null,
				// ✅ 冻结表头的兜底最大高度（px），随窗口高度重算
				fallbackMaxHeight: 520
			}
		},

		components: {
			AddForm
		},
		computed: {
			routeMeta() {
				return this.$route.meta.menu
			},
			showColumnList() {
				// 1. 先执行你原有的列显隐逻辑
				let list = this.columnList.filter((item) => {
					if (item.listShowFunction) {
						if (this.dataList.length) {
							return item.listShowFunction(this.dataList[0])
						}
						return false
					}
					return item.isShowList !== false && item.expand !== true
				})

				// ✅ 2. 核心逻辑：如果某一列没有数据（全为 null/undefined），则不显示该列
				if (this.dataList && this.dataList.length > 0) {
					list = list.filter(item => {
						// 如果没有配置 prop（比如操作列、多选列），或者是不需要拦截的列，直接保留
						if (!item.prop) return true
						
						// 检查这一列是否在所有数据行中都有值
						// 只要有一行数据包含该字段（且不为 null/undefined），这列就显示
						const hasValue = this.dataList.some(row => {
							const val = row[item.prop]
							return val !== null && val !== undefined && val !== ''
						})
						
						return hasValue
					})
				}

				return list
			},
			formListUpdate() {
			const formData = this.addData || {}
			return this.columnList
				.filter(item => item.form)
				.map(item => {
				let disabled = item.disabled
				if (typeof item.disabledFunction === 'function') {
					disabled = item.disabledFunction(formData)
				}
				return { ...item, disabled }
				})
			},
			// 展开行的列列表
			expandColumnList() {
				return this.columnList.filter((item) => {
					return item.expand === true
				})
			},
			// 没有显式高度时用 max-height 冻结表头。
			// el-table 同时设 height 和 max-height 时只认 height，所以两者互斥
			tableMaxHeight() {
				if (!this.freezeHeader) return null
				if (this.tableHeight) return null
				if (this.autoHeight && this.computedHeight) return null
				return this.maxHeight != null ? this.maxHeight : this.fallbackMaxHeight
			}
		},
		props: {
			isPageSubmit: {
				type: Boolean,
				default: false
			},
			isPageTitle: {
				type: Boolean,
				default: true
			},
			ifPageAdd: {
				type: Boolean,
				default: true
			},
			size: {
				type: String,
				default: 'small'
			},
			addFormBtn: {
				type: String,
				default: '保存'
			},
			addPopWidth: {
				type: String,
				default: '800px'
			},
			upDateApi: {
				type: String,
				default: ''
			},
			formApi: {
				type: String,
				default: ''
			},
			updateTitle: {
				type: String,
				default: '新增编辑'
			},
			selection: {
				type: Boolean,
				default: false
			},
			isPageForm: {
				type: Boolean,
				default: false
			},
			pageProp: {
				type: String,
				default: 'data'
			},
			pageTotal: {

				type: String,
				default: 'total'

			},
			apiUrl: {
				type: String,
				default: ''
			},
			columnList: {
				type: Array,
				default () {
					return []
				}
			},
			searchList: {
				type: Array,
				default () {
					return []
				}
			},

			defalutRequest: {
				type: Object,
				default () {
					return {}
				}
			},
			addFormList: {
				type: Array,
				default () {
					return []
				}
			},
			 pageMethod: {
				type: String,
				default:'get'
			},
			pageQuery: {
				type: Object,
				default () {
					return {
						page: "Page",
						size: "PageSize",
					}
				}
			},
			showExport: {
				type: Boolean,
				default: false // 默认不显示，需要时在页面开启
			},
			exportApi: {
				type: String,
				default: '' // 导出专用API，不填则使用当前列表API
			},
			exportColumns: {
				type: Array,
				default: null // 自定义导出列配置
			},
			exportFileName: {
				type: String,
				default: '数据导出' // 导出文件名
			},
			maxExportSize: {
				type: Number,
				default: 10000 // 最大导出数量
			},			
			rowKey: {
				type: [String, Function],
				default: 'id'
			},
			showExpand: {
				type: Boolean,
				default: false
			},
			// 是否显示表尾合计行
			showSummary: {
				type: Boolean,
				default: false
			},
			// 合计行第一列显示的文字
			summaryText: {
				type: String,
				default: '合计'
			},
			// ✅ 表格高度：传数字/字符串（如 500 或 'calc(100vh - 320px)'），表头固定、内部滚动
			tableHeight: {
				type: [String, Number],
				default: null
			},
			// ✅ 是否自适应视口高度（tableHeight 未传时生效）
			autoHeight: {
				type: Boolean,
				default: false
			},
			// ✅ 冻结表头用的最大高度（像素）。
			// 不传时按视口自动算（见 updateComputedHeight），表头固定、内容超高才出滚动条，
			// 行数少时又不会被撑高。传数值覆盖即可。
			// 注意：Element 内部要按 px 参与高度计算，所以这里用数字，不要传 calc()。
			maxHeight: {
				type: [String, Number],
				default: null
			},
			// ✅ 想还原成"整页滚动、表头跟着滚"的旧行为时传 false
			freezeHeader: {
				type: Boolean,
				default: true
			}
		},
		created() {
			// 先按视口算好兜底高度，避免首帧用默认值再跳一下
			this.updateComputedHeight()

			// 监听主题变化
			this.$root.$on('theme-change', (dark) => {
				this.isDark = dark
			})
			// 初始化主题
			this.isDark = localStorage.getItem('theme') === 'dark'

			// 尝试从 sessionStorage 恢复搜索条件
			const key = `tableList_${this.$route.path}_queryParams`
			const savedParams = sessionStorage.getItem(key)
			let restoredParams = {}
			if (savedParams) {
				try {
					restoredParams = JSON.parse(savedParams)
				} catch (e) {
					console.error('恢复搜索条件失败', e)
				}
			}

			this.getList()

			// 查询区：恢复查询值 + 加载下拉
			this.searchList.forEach((item) => {
				this.$set(this.queryParams, item.prop, restoredParams[item.prop] || null)
			})
			this.loadSelectOptions(this.searchList)

			// 表单区：加载下拉
			this.loadSelectOptions(this.columnList.filter(i => i.form))
		},
		mounted() {
			// ✅ 自适应高度初始化
			this.updateComputedHeight()
			window.addEventListener('resize', this.updateComputedHeight)
		},
		methods: {
			// ✅ 计算自适应表格高度
			updateComputedHeight() {
				if (this.autoHeight && !this.tableHeight) {
					// 340 为搜索区 + 卡片头 + 分页 + 外边距的估算值，可按实际布局调整
					this.computedHeight = window.innerHeight - 340
				}
				// 冻结表头的兜底高度：留出卡片头 + 搜索区 + 分页的空间，
				// 取数值而不是 calc()，Element 内部要拿它做 px 计算
				this.fallbackMaxHeight = Math.max(240, window.innerHeight - 360)
			},
			/**
			 * 通用：从响应里按路径取数组
			 * 默认取 res.data；如果配了 dataProp，则按点号路径取
			 */
			resolveDataList(res, item) {
				if (item.dataProp) {
					return item.dataProp.split('.').reduce((o, k) => o?.[k], res) || []
				}
				return res.data || []
			},

			/**
			 * 通用：把原始数据映射成 { label, value }
			 * 兼容 props 和 propData
			 */
			mapToOptions(dataList, item) {
				const propConf = item.props || item.propData
				if (!propConf || !Array.isArray(dataList)) return []

				const labelArr = propConf.label.split(',')
				return dataList.map((selectItem) => {
					const labelData = labelArr.map((labelItem) => selectItem[labelItem])
					return {
						label: labelData.join('-'),
						value: selectItem[propConf.value]
					}
				})
			},

			/**
			 * 通用：批量加载下拉数据
			 */
			loadSelectOptions(list) {
				list.forEach((item) => {
					if (item.api && (!item.selectList || item.selectList.length === 0)) {
						api.get(item.api, { PageSize: 5000 }).then((res) => {
							const dataList = this.resolveDataList(res, item)
							// ✅ 核心修改：必须用 $set，不要用 = 赋值
							this.$set(item, 'selectList', this.mapToOptions(dataList, item))
						})
					}
				})
			},

			/* 
			 @clear="handleClear(item)"
			    @change="handleChange"
			 */
			// 处理展开行变化
			handleExpandChange(row, expandedRows) {
				const key = row.id
				if (!key && key !== 0) return
				const isExpanded = expandedRows.includes(row)
				if (isExpanded) {
					if (!this.expandedRowKeys.includes(key)) {
						this.expandedRowKeys = [...this.expandedRowKeys, key]
					}
				} else {
					this.expandedRowKeys = this.expandedRowKeys.filter(k => k !== key)
				}
			},
			handleSelectionChange(rows) {
				this.selectedRows = rows
				this.$emit('selection-change', rows)
			},

			clearSelection() {
				this.$refs.tableRef && this.$refs.tableRef.clearSelection()
				this.selectedRows = []
			},
			handleClear(item){
				 this.isClearing = true
				this.queryParams[item.prop]=null
				
				this.getList('search')
			},
			handleChange(item){
				if(this.queryParams[item.prop]===''){
					return
				}
					  this.getList('search')
			},
			submitForm(data) {
				this.$emit('submitForm', data)
			},
			handleSizeChange(val) {
				this.queryParams.PageSize = val
				this.getList()
			},
			handleCurrentChange(val) {
				this.queryParams.Page = val
				this.getList()
			},
			changDaterange(e, item) {
				console.log(e, item)
				if (e && e.length) {
					this.queryParams[item.value1] = e[0]
					this.queryParams[item.value2] = e[1]
				} else {

					this.queryParams[item.value1] = null
					this.queryParams[item.value2] = null

				}
				this.getList('search')

			},
			handleAdd(data) {
				if (this.isPageForm) {
					this.$emit('openForm')
					return
				}
				this.addData = data || null
				this.addOpen = true
				if (data) {
					this.$nextTick(() => {
						this.$refs.addForm.setFormData(data)
					})
				}
			},
			async getList(type) {
				if (!this.apiUrl) {
					return
				}
				if (type === 'search' || type === "remove") {
					this.queryParams.Page = 1
					this.addOpen = false
				}
				if (type === 'remove') {

					this.searchList.forEach((item) => {
						this.queryParams[item.prop] = null
						if (item.type === 'daterange' || item.type === 'datetimerange') {
							this.queryParams[item.value1] = null
							this.queryParams[item.value2] = null
						}
					})

				}
				const requestData = JSON.parse(JSON.stringify(this.queryParams))
				// 删除日期范围类型的 prop（避免发送数组）
				this.searchList.forEach(item => {
					if (item.type === 'daterange' || item.type === 'datetimerange') {
						delete requestData[item.prop]
					}
				})				
				// ✅ 把标记为 isArray 的搜索项，从字符串解析成数组（支持逗号、中文逗号、换行）
				this.parseArrayFields(requestData)
				delete requestData.Page
				delete requestData.PageSize
				requestData[this.pageQuery.page] = this.queryParams.Page
				requestData[this.pageQuery.size] = this.queryParams.PageSize

				delete requestData.time
				this.loading = true;


				let res = null
				if(this.pageMethod==='get'){
					res = await api.get(
						this.apiUrl, {
							...requestData,
							...this.defalutRequest,
						}
					)
				}
				if(this.pageMethod==='post'){
					res = await api.post(
						this.apiUrl, {
							...requestData,
							...this.defalutRequest,
						}
					)
				}

				this.loading = false;
				if (!this.pageProp) {
					this.dataList = res.data
				} else {
					this.dataList = res.data[this.pageProp]
					this.total = res.data[this.pageTotal]
				}
				this.$emit('setTableList', this.dataList)

				return

				api.get(
					this.apiUrl, {
						...requestData,
						...this.defalutRequest,
					},
				).then((res) => {
					this.loading = false;
					if (!this.pageProp) {
						this.dataList = res.data
					} else {
						this.dataList = res.data[this.pageProp]
						this.total = res.data[this.pageTotal]
					}
					this.$emit('setTableList', this.dataList)

				})
			},
			/**
			 * 导出 Excel
			 */
			async handleExport() {
				try {
					// 确认导出
				await this.$confirm(`确定要导出数据吗？${this.total > this.maxExportSize ? `数据量较大(${this.total}条)，可能需要一些时间` : ''}`, '提示', {
						confirmButtonText: '确定',
						cancelButtonText: '取消',
						type: 'info'
					})

					const loading = this.$loading({
						lock: true,
						text: '正在导出数据，请稍候...',
						spinner: 'el-icon-loading'
					})

					// 获取所有数据
					let list = []
					const exportApi = this.exportApi || this.apiUrl
					const requestData = this.buildExportParams()

					if (this.pageMethod === 'get') {
						const res = await api.get(exportApi, requestData)
						list = this.pageProp ? res.data[this.pageProp] : res.data
					} else if (this.pageMethod === 'post') {
						const res = await api.post(exportApi, requestData)
						list = this.pageProp ? res.data[this.pageProp] : res.data
					}

					if (!list || list.length === 0) {
						this.$message.warning('没有数据可导出')
						loading.close()
						return
					}

					// 格式化数据
					const exportData = this.formatExportData(list)
					
					// 生成 Excel
					this.downloadExcel(exportData)
					
					loading.close()
					this.$message.success(`导出成功，共 ${exportData.length} 条数据`)
				} catch (error) {
					if (error !== 'cancel') {
						console.error('导出失败:', error)
						this.$message.error('导出失败')
					}
				}
			},

			/**
			 * 构建导出请求参数
			 */
			buildExportParams() {
				const requestData = JSON.parse(JSON.stringify(this.queryParams))
				
				// 删除日期范围类型的 prop
				this.searchList.forEach(item => {
					if (item.type === 'daterange' || item.type === 'datetimerange') {
						delete requestData[item.prop]
					}
				})
				this.parseArrayFields(requestData)
				delete requestData.Page
				delete requestData.PageSize
				
				// 导出全部数据，不分页
				requestData[this.pageQuery.page] = 1
				requestData[this.pageQuery.size] = this.maxExportSize // 最大导出数量
				
				return {
					...requestData,
					...this.defalutRequest
				}
			},
			parseArrayFields(requestData) {
				this.searchList.forEach(item => {
					if (item.isArray) {
						const val = requestData[item.prop]
						if (val) {
							const arr = val
								.split(/[,，\s\n\r]+/)
								.map(s => s.trim())
								.filter(s => s)
							requestData[item.prop] = arr.length ? arr : null
						} else {
							requestData[item.prop] = null
						}
					}
				})
				return requestData
			},
			/**
			 * 格式化导出数据
			 */
			formatExportData(list) {
				// 使用自定义导出列，或默认使用 columnList
				const columns = this.exportColumns || this.columnList.filter(item => 
					item.prop && item.isShowList !== false
				)

				return list.map(item => {
					const row = {}
					columns.forEach(col => {
						let value = item[col.prop]
						
						// 如果列有 showFunction，使用它格式化
						if (col.showFunction) {
							const result = col.showFunction(value, item)
							row[col.label] = result.text || ''
						} else {
							// 处理特殊类型
							if (col.type === 'img') {
								row[col.label] = value || ''
							} else if (col.prop === 'status') {
								// 状态字段特殊处理（可配置化）
								row[col.label] = value === 1 ? '启用' : '停用'
							} else {
								row[col.label] = value ?? ''
							}
						}
					})
					return row
				})
			},
			/**
			 * 表尾合计行
			 * 只对 columnList 中标记了 summary: true 的列求和
			 * 支持的列级配置：
			 *   summary: true        —— 该列参与合计
			 *   summaryFixed: 0/2    —— 保留小数位，默认 2
			 *   summaryText: '小计'  —— 该列合计行的前缀（可选）
			 *
			 * @param {Object} param0 { columns, data }
			 * @returns {Array} 每列显示的合计文本
			 */
			summaryMethod({ columns, data }) {
				const sums = []
				// 构建 prop -> columnList 配置 的映射
				const propMap = {}
				this.columnList.forEach(item => {
					if (item.prop) {
						propMap[item.prop] = item
					}
				})

				columns.forEach((column, index) => {
					// 第一列显示"合计"（可用 summaryText 覆盖）
					if (index === 0) {
						sums[index] = this.summaryText
						return
					}

					const prop = column.property
					const config = propMap[prop]

					// 没标 summary 的列不合计
					if (!prop || !config || !config.summary) {
						sums[index] = ''
						return
					}

					// 累加当前页数据
					const values = data.map(item => Number(item[prop]) || 0)
					const total = values.length
						? values.reduce((acc, cur) => acc + cur, 0)
						: 0

					// 小数位处理
					const fixed = config.summaryFixed !== undefined ? config.summaryFixed : 2
					const prefix = config.summaryText || ''
					sums[index] = prefix + total.toFixed(fixed)
				})

				return sums
			},
			/**
			 * 下载 Excel
			 */
			downloadExcel(data) {
				const wb = XLSX.utils.book_new()
				const ws = XLSX.utils.json_to_sheet(data)
				
				// 设置列宽（自适应）
				const colWidths = Object.keys(data[0] || {}).map(key => ({
					wch: Math.max(key.length * 2, 15)
				}))
				ws['!cols'] = colWidths
				
				XLSX.utils.book_append_sheet(wb, ws, 'Sheet1')
				
				const fileName = `${this.exportFileName}_${new Date().getTime()}.xlsx`
				XLSX.writeFile(wb, fileName)
			}

		},
		beforeDestroy() {
			// 移除事件监听
			this.$root.$off('theme-change')
			// ✅ 移除 resize 监听
			window.removeEventListener('resize', this.updateComputedHeight)
		}
	};
</script>

<style scoped>
	.app-container {
		background-color: var(--bg-color-light);
		transition: all 0.3s ease;
	}

	.table-card {
		background-color: var(--bg-color);
		border-color: var(--border-color);
		transition: all 0.3s ease;
	}

	.table-card ::v-deep .el-card__header {
		border-bottom-color: var(--border-color);
	}

	.table-card ::v-deep .el-table {
		background-color: var(--bg-color);
		color: var(--text-color);
	}

	.table-card ::v-deep .el-table th {
		background-color: var(--bg-color-light);
		color: var(--text-color);
		border-color: var(--border-color);
	}

	.table-card ::v-deep .el-table td {
		border-color: var(--border-color);
	}

	.table-card ::v-deep .el-table tr {
		background-color: var(--bg-color);
	}

	.table-card ::v-deep .el-table--enable-row-hover .el-table__body tr:hover>td {
		background-color: var(--bg-color-light);
		color: var(--text-color);
	}

	.table-card ::v-deep .el-table--small {
		--hover-bg-color: #f5f7fa;
		--hover-text-color: #303133;
	}

	.table-card ::v-deep .dark-theme .el-table--enable-row-hover .el-table__body tr:hover>td {
		background-color: #404040 !important;
		color: #e4e7ed !important;
	}

	.table-card ::v-deep .el-form-item__label {
		color: var(--text-color);
	}

	.table-card ::v-deep .el-input__inner {
		background-color: var(--bg-color-light);
		border-color: var(--border-color);
		color: var(--text-color);
	}

	.table-card ::v-deep .el-input__inner::placeholder {
		color: var(--text-color-secondary);
	}

	.table-card ::v-deep .el-select .el-input__inner {
		background-color: var(--bg-color-light);
	}

	.table-card ::v-deep .el-cascader {
		background-color: var(--bg-color-light);
	}

	.table-card ::v-deep .el-pagination {
		background-color: var(--bg-color);
	}

	.table-card ::v-deep .el-pager li {
		background-color: var(--bg-color-light);
		color: var(--text-color);
	}

	.table-card ::v-deep .el-pager li.active {
		background-color: var(--primary-color);
		color: #fff;
	}

	.table-card ::v-deep .el-button--default {
		background-color: var(--bg-color-light);
		border-color: var(--border-color);
		color: var(--text-color);
	}

	/* 暗黑模式表格行背景 */
	.dark-theme .el-table--border,
	.el-table--group {
		border-color: #333333 !important;
	}

	.dark-theme .table-card ::v-deep .el-table__body .el-table__row {
		background-color: #2a2a2a !important;
		color: #e4e7ed !important;
	}

	.dark-theme .table-card ::v-deep .el-table__body .hover-row .el-table__cell {
		background-color: #404040 !important;
		color: #ffffff !important;
	}

	/* 暗黑模式斑马纹样式 */
	.dark-theme .table-card ::v-deep .el-table__body .hover-row .el-table__cell {
		background-color: #333333 !important;
	}
</style>